import { UNLEASH_FEATURE_NAME } from 'node_modules/@schibsted-nmp/advertising-shared/src/index.js';

import { isFeatureEnabled } from '@client/core/atoms/unleashFeatures.js';
import { isFinnTravelObjectPage } from '@client/core/utils/travel/isFinnTravelObjectPage.js';
import { isFinnTravelResultPage } from '@client/core/utils/travel/isFinnTravelResultPage.js';

export function ensurePathStartsWithSlash(path: string): string {
  return path.startsWith('/') ? path : `/${path}`;
}

export function removeWallpaperDiv() {
  const wallpaperDiv =
    typeof document !== 'undefined' &&
    document.getElementById('wallpaper-container');

  if (wallpaperDiv) wallpaperDiv.remove();
}

export function shouldUseSplitBatch() {
  return (
    isFeatureEnabled(UNLEASH_FEATURE_NAME.enableBatchRequestSplit) &&
    !isFinnTravelResultPage() &&
    !isFinnTravelObjectPage()
  );
}
